function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.111,7.222h18.889v2.222H11.111v-2.222ZM11.111,11.667h18.889v2.222H11.111v-2.222ZM0,16.111h30v2.222H0v-2.222ZM0,20.556h30v2.222H0v-2.222Z",
    style: {
      fill: "#0038a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.304,11.642l.368.549c-1.511,1.094-.589,1.74-1.66,2.091.666-.65-.088-.75.473-2.105",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.874,14.366l.113-.11c.322-.314.3-.482.265-.762-.035-.274-.083-.648.2-1.331l.014-.034.068.028-.014.034c-.275.665-.229,1.029-.195,1.294.032.247.055.434-.177.707.354-.154.408-.358.48-.63.09-.34.213-.805.995-1.38l-.369-.551.061-.041.408.609-.029.021c-.787.57-.903,1.008-.996,1.36-.083.315-.149.564-.674.736l-.15.05Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.609,11.146l-.128.648c-1.842-.295-1.647.814-2.652.305.931.011.489-.601,1.844-1.162",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.298,12.271c-.132,0-.287-.039-.485-.14l-.141-.071.158.002c.451.005.565-.139.738-.358s.411-.52,1.092-.802l.034-.014.028.068-.034.014c-.664.275-.885.555-1.062.78-.158.2-.278.351-.637.381.359.141.542.035.784-.106.304-.177.719-.419,1.679-.272l.129-.65.072.014-.142.719-.035-.006c-.959-.154-1.351.074-1.666.257-.169.099-.316.184-.512.184Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.609,11.146l-.29-.052.003.012c-.774.19-1.195.511-1.524.755-.165.122-.307.226-.461.282-.102.038-.212.051-.32.038.799.284.746-.661,2.464-.386l.128-.649Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.298,12.251c-.084,0-.177-.016-.286-.055l-.139-.049.146.017c.105.012.213,0,.312-.037.156-.057.302-.165.457-.28l.023-.017c.331-.245.741-.55,1.49-.736l-.005-.021.332.06-.135.681-.016-.003c-.966-.155-1.362.075-1.679.259-.167.098-.31.181-.5.181ZM2.144,12.2c.264.059.425-.035.638-.159.321-.186.719-.418,1.685-.266l.122-.616-.248-.045v.003s-.015.004-.015.004c-.753.185-1.164.49-1.495.735l-.023.017c-.157.116-.305.226-.465.284-.064.025-.131.039-.199.043Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.097,12.186c-.086,0-.178-.016-.28-.052l.024-.069c.378.134.6-.031.936-.28.32-.237.757-.562,1.528-.75l.017.071c-.756.185-1.169.492-1.501.738-.258.191-.462.342-.724.342Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556l-.519-.518-2.333,3.37,3.371-2.333-.519-.519-2.852,2.852",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.559,13.552l2.473-3.572,1.099,1.099-3.572,2.473ZM5.556,10.607l-2.538,2.538,3-2.077-.462-.461ZM5.042,10.094l-2.077,3,2.539-2.539-.462-.461Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.469,10.304l-.549.368c-1.094-1.511-1.741-.589-2.091-1.66.65.666.757-.087,2.112.475",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.911,10.722l-.021-.029c-.57-.787-1.008-.903-1.36-.996-.315-.083-.564-.149-.736-.674l-.049-.15.11.113c.314.322.484.301.765.265.275-.035.651-.082,1.334.201l.034.014-.028.068-.034-.014c-.665-.275-1.015-.231-1.297-.196-.249.031-.437.055-.711-.178.154.354.358.408.63.48.34.09.805.213,1.38.995l.55-.369.041.061-.608.409Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.469,10.304l-.168-.242-.006.011c-.682-.413-1.206-.484-1.611-.544-.203-.03-.376-.057-.525-.127-.099-.045-.186-.114-.253-.199.365.766.996.06,2.015,1.469l.548-.368Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.916,10.695l-.009-.013c-.574-.793-1.016-.91-1.371-1.004-.271-.072-.484-.128-.646-.468l-.063-.133.091.115c.066.083.151.15.247.194.15.07.33.097.521.125l.03.004c.407.06.912.136,1.574.533l.011-.018.193.277-.578.388ZM1.98,9.306c.145.228.326.276.564.339.358.095.804.213,1.38,1.004l.522-.349-.144-.207-.002.002-.014-.009c-.662-.402-1.169-.477-1.576-.537l-.03-.004c-.193-.029-.375-.056-.53-.128-.061-.028-.119-.066-.17-.111Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.294,10.072c-.665-.404-1.174-.479-1.583-.54-.421-.062-.725-.108-.915-.505l.066-.032c.173.362.446.402.859.464.394.058.933.138,1.611.55l-.038.063Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556v-.733l-4.033.733,4.033.733v-.733H1.522",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.592,11.333l-4.275-.777,4.275-.777v1.554ZM1.929,10.592l3.59.653v-.653H1.929ZM1.929,10.519h3.59v-.653l-3.59.653Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556v.733-.733H1.522l4.033.733",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.965,9.609l-.648-.128c.295-1.842-.815-1.647-.305-2.652-.011.931.633.564,1.194,1.919",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.994,9.653l-.719-.142.006-.035c.154-.959-.074-1.351-.258-1.666-.164-.282-.294-.504-.044-.997l.071-.141-.002.158c-.006.456.148.585.38.781.224.189.531.448.811,1.123l.014.034-.068.028-.014-.034c-.273-.658-.56-.9-.79-1.095-.211-.178-.371-.313-.401-.68-.142.359-.035.542.106.785.177.304.419.719.272,1.68l.65.129-.014.072Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.965,9.61l.052-.29-.012.003c-.19-.774-.511-1.195-.755-1.524-.122-.165-.226-.307-.282-.461-.038-.102-.051-.212-.038-.32-.284.799.661.746.386,2.464l.649.128Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.978,9.629l-.681-.135.003-.016c.155-.966-.075-1.362-.259-1.679-.141-.242-.252-.433-.126-.787l.049-.139-.017.146c-.012.105,0,.213.037.312.057.156.165.302.28.457l.017.023c.245.33.55.741.736,1.49l.021-.005-.06.333ZM4.336,9.468l.616.122.045-.248h-.003s-.004-.015-.004-.015c-.184-.753-.489-1.164-.735-1.495l-.017-.023c-.116-.157-.226-.305-.284-.465-.024-.064-.038-.131-.042-.199-.059.264.035.425.159.638.185.32.416.719.265,1.685Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.005,9.322c-.185-.756-.492-1.169-.738-1.501-.254-.342-.437-.589-.29-1.004l.069.024c-.134.378.031.6.28.936.237.32.562.757.75,1.528l-.071.017Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556l.519-.518-3.371-2.333,2.333,3.37.519-.519-2.852-2.852",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.032,11.131l-2.473-3.572,3.573,2.473-1.1,1.099ZM2.965,8.017l2.077,3,.462-.462-2.539-2.538ZM3.017,7.965l2.538,2.538.462-.461-3-2.077Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556l-.519.519.519-.519-2.852-2.852,2.333,3.371",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.807,9.469l-.368-.549c1.511-1.094.589-1.74,1.66-2.091-.666.65.084.757-.477,2.112",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.797,9.52l-.408-.609.029-.021c.787-.57.903-1.008.996-1.36.083-.315.149-.564.674-.736l.15-.049-.113.11c-.322.314-.301.484-.266.766.034.275.08.652-.202,1.334l-.014.034-.068-.028.014-.034c.275-.664.232-1.015.197-1.297-.031-.25-.054-.438.179-.712-.354.154-.408.358-.48.63-.09.34-.213.805-.995,1.38l.369.55-.062.042Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.807,9.469l.242-.168-.011-.006c.413-.682.484-1.206.544-1.611.03-.203.057-.377.127-.525.045-.099.114-.186.199-.253-.766.364-.06.995-1.469,2.015l.368.548Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.803,9.492l-.386-.577.013-.009c.793-.574.91-1.016,1.004-1.371.072-.271.128-.484.468-.646l.133-.063-.115.091c-.083.066-.15.151-.194.247-.07.15-.097.33-.125.521l-.004.029c-.06.407-.135.913-.533,1.575l.016.011-.277.192ZM5.462,8.924l.35.522.207-.144-.003-.002.009-.014c.402-.663.477-1.169.538-1.576l.004-.029c.029-.193.056-.375.128-.53.028-.062.066-.119.111-.171-.228.145-.276.325-.339.564-.096.358-.214.804-1.005,1.38Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.101,9.332l-.063-.038c.404-.665.479-1.174.54-1.583.062-.421.108-.725.505-.915l.032.066c-.362.173-.402.446-.464.859-.058.394-.138.933-.55,1.611Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556h.733l-.733-4.033-.733,4.033h.733v-4.033",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.333,10.592h-1.555l.777-4.275.778,4.275ZM5.592,10.519h.653l-.653-3.59v3.59ZM4.866,10.519h.653v-3.59l-.653,3.59Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556h-.734.734v-4.033l-.733,4.033",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.502,9.965l.128-.648c1.842.295,1.647-.815,2.652-.305-.931-.011-.516.604-1.871,1.166",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.391,10.225l-.028-.068.034-.014c.661-.274.89-.554,1.074-.779.165-.202.291-.355.653-.385-.359-.141-.542-.035-.785.106-.304.177-.719.419-1.679.272l-.129.65-.072-.014.142-.719.035.006c.959.154,1.351-.074,1.666-.257.282-.164.504-.294.997-.044l.141.071-.158-.002c-.454-.006-.573.141-.754.363-.179.219-.425.519-1.102.8l-.035.014Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.502,9.965l.29.052-.003-.012c.774-.19,1.195-.511,1.524-.755.165-.122.307-.226.461-.282.102-.038.212-.051.32-.038-.799-.284-.746.661-2.464.386l-.128.649Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.814,10.038l-.332-.06.135-.681.016.003c.966.155,1.362-.075,1.679-.259.242-.141.433-.252.787-.126l.139.049-.146-.017c-.105-.012-.213,0-.312.037-.156.057-.302.165-.457.28l-.023.017c-.331.245-.741.55-1.491.737l.005.02ZM6.521,9.952l.248.045v-.003s.015-.004.015-.004c.753-.185,1.165-.49,1.495-.735l.023-.017c.157-.116.305-.226.465-.284.064-.024.131-.038.199-.042-.264-.059-.425.035-.638.159-.32.186-.719.418-1.685.266l-.122.615Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.806,10.077l-.017-.071c.756-.185,1.169-.492,1.501-.738.342-.254.589-.437,1.004-.29l-.024.069c-.378-.134-.6.031-.936.28-.32.236-.757.561-1.528.75Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556l.519.519,2.333-3.37-3.371,2.333.519.518,2.852-2.852",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.079,11.131l-.524-.524h0l-.576-.575,3.573-2.473-2.473,3.572ZM5.607,10.555l.462.462,2.077-3-2.539,2.538ZM5.094,10.042l.462.461,2.538-2.538-3,2.077Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556l-.519-.518.519.518,2.852-2.852-3.371,2.334",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.642,10.807l.549-.368c1.094,1.511,1.741.589,2.091,1.66-.65-.666-.772.079-2.127-.482",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.366,12.237l-.11-.113c-.315-.323-.498-.301-.775-.269-.278.033-.659.077-1.34-.205l-.034-.014.028-.068.034.014c.664.275,1.018.233,1.303.2.254-.03.446-.052.72.181-.154-.354-.358-.408-.63-.48-.34-.09-.805-.213-1.38-.995l-.55.369-.041-.061.609-.408.021.029c.57.787,1.008.903,1.36.996.315.083.564.149.736.674l.049.15Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.642,10.807l.168.242.006-.011c.682.413,1.206.484,1.611.544.203.03.377.057.525.127.099.045.186.114.253.199-.364-.766-.996-.06-2.015-1.469l-.548.368Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.285,12.034l-.091-.115c-.066-.083-.151-.15-.247-.194-.151-.07-.33-.097-.521-.125l-.029-.004c-.407-.06-.913-.136-1.574-.533l-.011.019-.193-.277.577-.386.009.013c.574.793,1.016.91,1.371,1.004.271.072.484.128.646.468l.063.13ZM6.811,11.016l.014.009c.663.402,1.169.477,1.576.538l.029.004c.193.029.375.056.53.128.062.028.119.066.171.111-.145-.228-.325-.276-.564-.339-.358-.095-.804-.213-1.38-1.004l-.522.35.144.207.002-.004Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.249,12.115c-.173-.362-.446-.402-.859-.464-.394-.058-.933-.138-1.611-.55l.038-.063c.665.404,1.174.479,1.584.54.421.062.725.108.915.505l-.067.032Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556v.733l4.033-.733-4.033-.733v.733h4.033",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.519,11.333v-1.555l4.275.777-4.275.778ZM5.592,10.592v.653l3.59-.653h-3.59ZM5.592,10.519h3.59l-3.59-.653v.653Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556v-.733.733h4.033l-4.033-.733",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.146,11.502l.649.128c-.295,1.842.814,1.647.305,2.652.011-.931-.602-.5-1.163-1.855",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.061,14.439l.002-.158c.005-.452-.14-.568-.359-.744-.219-.176-.519-.416-.801-1.096l-.014-.034.068-.028.014.034c.274.662.554.887.779,1.067.201.161.353.283.382.643.141-.359.035-.542-.106-.784-.177-.304-.419-.719-.272-1.68l-.65-.129.014-.072.719.142-.006.035c-.154.959.074,1.351.257,1.666.164.282.294.504.044.997l-.071.141Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.146,11.502l-.052.29.012-.003c.19.774.511,1.195.755,1.524.122.165.226.307.282.461.038.102.051.212.039.32.284-.799-.661-.746-.386-2.464l-.65-.128Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.147,14.238l.017-.146c.012-.105,0-.213-.038-.312-.057-.156-.165-.302-.28-.457l-.017-.023c-.245-.331-.55-.741-.736-1.49l-.021.005.06-.332.681.135-.003.016c-.155.966.075,1.362.26,1.679.141.242.252.433.126.787l-.049.138ZM6.118,11.769l.004.016c.185.753.49,1.164.735,1.495l.017.023c.116.157.226.305.284.465.024.064.038.131.042.199.059-.264-.035-.425-.159-.639-.186-.32-.418-.719-.266-1.685l-.616-.122-.045.248h.004Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.133,14.294l-.069-.024c.134-.378-.031-.6-.28-.935-.237-.32-.562-.757-.75-1.528l.071-.017c.185.756.491,1.169.738,1.501.254.341.437.588.29,1.003Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556l-.519.519,3.371,2.333-2.333-3.371-.519.519,2.852,2.852",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.553,13.552l-3.573-2.473,1.099-1.099,2.474,3.572ZM5.094,11.069l3,2.077-2.539-2.539-.461.462ZM5.607,10.556l2.539,2.539-2.077-3-.462.461Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556l.519-.518-.519.518,2.852,2.852-2.333-3.371",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.304,11.642l-.242.168.011.006c-.413.682-.484,1.206-.544,1.611-.03.203-.057.377-.127.525-.045.099-.114.186-.199.253.766-.364.06-.996,1.469-2.015l-.368-.548Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.078,14.285l.115-.091c.083-.066.15-.151.194-.247.07-.15.097-.33.125-.521l.004-.03c.061-.407.136-.912.533-1.573l-.018-.011.277-.193.386.577-.013.009c-.793.574-.91,1.016-1.004,1.371-.072.271-.128.484-.468.646l-.131.063ZM5.093,11.809l.003.002-.009.014c-.402.662-.477,1.169-.537,1.575l-.004.03c-.029.193-.056.375-.128.53-.028.062-.066.12-.111.171.228-.145.276-.326.339-.564.095-.358.213-.804,1.004-1.38l-.35-.522-.207.144Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.028,14.315l-.032-.066c.362-.173.402-.446.464-.859.058-.394.138-.933.55-1.611l.063.038c-.404.665-.479,1.174-.54,1.583-.063.421-.108.725-.505.915Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556h-.734l.733,4.033.733-4.033h-.732v4.033",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,14.794l-.777-4.275h1.555l-.778,4.275ZM5.592,10.592v3.59l.653-3.59h-.653ZM4.866,10.592l.653,3.59v-3.59h-.653Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556h.733-.733v4.033l.733-4.033",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,10.556l.519.519-.519-.519-2.852,2.852,3.371-2.333",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.556,
    cy: 10.556,
    r: 1.344,
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.556,11.937c-.762,0-1.381-.62-1.381-1.381s.62-1.381,1.381-1.381,1.381.62,1.381,1.381-.62,1.381-1.381,1.381ZM5.556,9.248c-.721,0-1.308.587-1.308,1.308s.587,1.308,1.308,1.308,1.308-.587,1.308-1.308c-.001-.722-.587-1.308-1.308-1.308Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.546,10.018c-.086.098-.134-.073-.44-.073s-.354.183-.403.146.257-.257.355-.269c.096-.012.377.086.488.196M6.191,10.128c.086.073.012.232-.073.232s-.244-.147-.171-.245",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.788,10.238c.012-.147.135-.171.33-.171.196,0,.281.147.355.183-.086,0-.159-.122-.354-.122s-.196,0-.33.122M5.824,10.274c.049-.073.11.073.244.073s.208-.037.293-.098c.086-.061-.122.147-.257.147s-.316-.073-.28-.122M4.871,10.116c-.061.024-.159.147,0,.232-.122-.086-.024-.208,0-.232Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24,10.116c.024.024.122.147,0,.232.159-.086.061-.208,0-.232ZM5.36,10.641c-.11.024-.073.183-.171.196-.098.012-.147.122-.134.11.061-.049.196-.086.293-.086.098,0,.122.061.208.061s.11-.061.208-.061.232.037.293.086c.012.012-.037-.098-.134-.11-.098-.012-.061-.171-.171-.196,0,.049.037.037.049.11,0,.061-.11.061-.134,0,.024.098-.049.098-.11.098s-.134,0-.11-.098c-.024.061-.134.061-.134,0,.01-.073.047-.061.047-.11ZM4.981,11.057c-.098.073-.122.11-.134.196.029-.051.044-.072.066-.103l-.017-.007c.007,0,.013.002.02.003.015-.021.028-.038.065-.089h0Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.916,11.145l-.002.002c.015.004.032.005.048.005-.015-.002-.03-.005-.046-.007h0ZM4.963,11.153c.076.013.136.031.191.049.068-.005.163-.022.402-.022s.333.017.402.022c.055-.018.115-.035.191-.049-.135,0-.314-.096-.397-.096-.098,0-.122.024-.195.024s-.098-.024-.196-.024c-.084,0-.263.096-.398.096h0ZM6.148,11.153c.017,0,.033-.002.049-.005l-.002-.002c-.016.002-.032.004-.047.007h0Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.195,11.145c.007,0,.013-.002.02-.003-.006.003-.011.005-.017.007.022.03.037.051.066.103-.012-.086-.037-.122-.134-.196.037.052.05.069.065.089h0Z",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.199,11.15s0-.001,0,0c-.128.048-.173.057-.241.052-.116.038-.211.075-.402.075s-.286-.038-.402-.075c-.068.005-.113-.003-.24-.052,0,0,0,0,0,0,.384.165.342.225.643.225s.258-.061.643-.226h0ZM4.913,11.149s0,0,0-.002c-.006,0-.013-.003-.019-.005.008.003.012.004.018.007h0ZM6.198,11.149c.006-.003.011-.004.018-.007-.006.002-.012.004-.019.005,0,.001,0,.001,0,.002h0ZM4.566,10.018c.086.098.134-.073.44-.073s.354.183.403.146-.257-.257-.354-.269c-.098-.012-.379.086-.489.196M4.92,10.128c-.086.073-.012.232.073.232s.245-.147.171-.245",
    style: {
      fill: "#7b3f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.323,10.238c-.012-.147-.134-.171-.33-.171s-.281.147-.355.183c.086,0,.159-.122.354-.122q.196,0,.33.122M5.287,10.274c-.049-.073-.11.073-.244.073s-.208-.037-.293-.098c-.086-.061.122.147.257.147s.316-.073.28-.122M5.556,11.484c-.061,0-.22.037,0,.037s.061-.037,0-.037",
    style: {
      fill: "#7b3f00"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/UY.6a6447058fcdf872908304712c7c85c7.svg";
export { ForwardRef as ReactComponent };